<template>
  <div class="">
    <!-- 查询表单 -->
    <div>
      <el-form ref="queryParamForm" :model="queryParamForm" label-width="90px">
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item label="分类">
              <el-select
                  clearable
                  v-model="queryParamForm.categoryId"
                  placeholder="请选择"
                  @change="changeOtherOptions(true)"
              >
                <el-option
                    v-for="item in queryCategoryOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="品牌">
              <el-select
                  clearable
                  v-model="queryParamForm.brandId"
                  placeholder="请选择"
                  @change="getModelList(true)"
              >
                <el-option
                    v-for="item in queryBrandOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="机型">
              <el-select
                  clearable
                  v-model="queryParamForm.modelId"
                  placeholder="请选择"
                  filterable
                  @change="getQuerySkuList()"
              >
                <el-option
                    v-for="item in queryModelList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
           <el-col :span="6">
            <el-form-item label="SKU名称">
              <el-select
                  clearable
                  v-model="queryParamForm.skuId"
                  placeholder="请选择"
                  filterable
              >
                <el-option
                    v-for="item in querySkuList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="等级">
              <el-select
                  clearable
                  v-model="queryParamForm.gradeId"
                  placeholder="请选择"
              >
                <el-option
                    v-for="item in queryGradeList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item label="定价回收商">
              <el-select
                  clearable
                  v-model="queryParamForm.serviceId"
                  placeholder="请选择"
              >
                <el-option
                    v-for="item in queryServiceList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
           <el-col :span="6">
            <el-form-item label="创建人">
              <el-input
                  clearable
                  v-model="queryParamForm.createBy"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2.5">
            <el-button type="primary" @click="getModelPriceListSearch"
            >查询
            </el-button
            >
            <el-button type="primary" @click="addBasePrice">创建</el-button>
             <el-button type="primary" @click="batchCheck">批量更新价格</el-button>
             <el-button type="primary" style="background-color: red;color: white;border: none;" @click="checkModelPriceChangeApplyAllPrice">批量检测</el-button>
          </el-col>
          <el-col :span="3.8">
            <el-upload
                style="display:inline"
                action="aa"
                :show-file-list="false"
                :before-upload="importSendInfo">
              <el-button style="margin-left:10px" type="primary" v-loading="fullscreenLoading">批量导入</el-button>
            </el-upload>
          </el-col>
          <el-col :span="3" style="margin-top:10px">
            <a type="primary" @click="getSkuTemplete">模板下载</a>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="margin-top: 20px;">
      <!-- 表格 -->
      <el-table v-loading="listLoading" :data="tableData" border style="width: 100%">
        <el-table-column prop="id" label="ID"></el-table-column>
        <el-table-column prop="serviceName" label="定价回收商">
        </el-table-column>
        <el-table-column prop="modelName" label="机型"></el-table-column>
        <el-table-column prop="skuIdName" label="SKU名称"></el-table-column>
        <el-table-column prop="brandName" label="品牌"></el-table-column>
        <el-table-column prop="categoryName" label="分类"></el-table-column>
        <el-table-column prop="gradeName" label="等级"></el-table-column>
        <el-table-column prop="price" label="基准价格"></el-table-column>
        <el-table-column prop="createTime" label="创建时间"></el-table-column>
        <el-table-column prop="createBy" label="操作人"></el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 1">执行中</span>
            <span v-else-if="scope.row.status === 2">成功</span>
             <span v-else-if="scope.row.status === 3">失败</span>
            <span v-else>待审核</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button @click="editormodel(scope.row)" type="text" size="small"
            >编辑
            </el-button
            >
            <el-button
                @click="changeStatus(scope.row, 1)"
                type="text"
                size="small"
                v-if="scope.row.status!=1"
            >更新价格
            </el-button
            >
            <el-button @click="deleteBasePrice(scope.row.id)" type="text" size="small" style="color: red;">删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
          style="margin-top: 20px;"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 40, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="tableTotal"
      >
      </el-pagination>
    </div>

    <!-- 修改或新建对话框 -->
    <el-dialog
        :title="
        dlgType === 'change' ? '编辑基准价' : '新建基准价'
      "
        :visible.sync="isDlg"
        width="700px"
    >
      <div style="margin: 20px;">
        <div>
          <el-form
              ref="editBasePriceForm"
              :model="editBasePriceForm"
              :rules="editorFormRules"
              label-width="120px"
          >
            <el-form-item label="编号" v-if="dlgType === 'change'">
              <el-input
                  clearable
                  v-model="editBasePriceForm.id"
                  :disabled="true"
              ></el-input>
            </el-form-item>
            <el-form-item label="定价回收商" prop="serviceId">
              <el-select
                  clearable
                  v-model="editBasePriceForm.serviceId"
                  placeholder="请选择"
              >
                <el-option
                    v-for="item in queryServiceList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="分类" prop="categoryId">
              <el-select
                  clearable
                  v-model="editBasePriceForm.categoryId"
                  placeholder="请选择"
                  @change="changeOtherOptions(false)"
              >
                <el-option
                    v-for="item in queryCategoryOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="品牌" prop="brandId">
              <el-select
                  clearable
                  v-model="editBasePriceForm.brandId"
                  placeholder="请选择"
                  @change="changeBrand(false)"
              >
                <el-option
                    v-for="item in editBrandOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="机型" prop="modelId">
              <el-select
                  clearable
                  v-model="editBasePriceForm.modelId"
                  placeholder="请选择"
                  filterable
                  @change="changeSkuList()"
              >
                <el-option
                    v-for="item in editModelList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="SKU名称" prop="skuId">
              <el-select
                  clearable
                  v-model="editBasePriceForm.skuId"
                  placeholder="请选择"
                  filterable
                  @change="changeSku"
              >
                <el-option
                    v-for="item in editSkuList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="等级" prop="gradeId">
              <el-select
                  clearable
                  v-model="editBasePriceForm.gradeId"
                  placeholder="请选择"
                  @change="changeGrade()"
              >
                <el-option
                    v-for="item in editGradeList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="基准价格">
              <el-row>
                  <el-input clearable v-model="editBasePriceForm.price"></el-input>
              </el-row>
            </el-form-item>
          </el-form>
        </div>
        <div style="text-align: center;">
          <el-button
              type="primary"
              style="margin: 30px 20px;"
              @click="checkModelPriceChangeApplyPrice"
          >校验倒挂
        </el-button>
          <el-button
              type="primary"
              style="margin: 30px 20px;"
              @click="submitEditor"
          >确定
          </el-button
          >
          <el-button style="margin: 10px 20px;" @click="closeEditormodelDlg"
          >暂不
          </el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {

      // 查询数据
      queryParamForm: {
        categoryId: null,
        modelId: null,
        brandId: null,
        gradeId: null,
        serviceId: null,
        skuId:null,
        createBy:null
      },

      // 表格数据
      tableTotal: 0,
      tableData: [],
      pageSize: 10,
      currentPage: 1,

      scopeOptions: [{
        value: 0,
        label: '通用'
      }, {
        value: 1,
        label: '部分渠道适用'
      },],

      priceOptions: [{
        value: 0,
        label: '固定值'
      }, {
        value: 1,
        label: '计算值'
      },],

      calculationOptions: [{
        value: 0,
        label: '固定'
      }, {
        value: 1,
        label: '比例'
      },],
      // 新建编辑对话框数据

      isDlg: false,
      editBasePriceForm: {
        id: null,
        value: null,
        price: 0,
        categoryId: null,
        modelId: null,
        brandId: null,
        gradeId: null,
        scope: null,
        scopeMerchant: null,
        serviceId: null,
        skuId: null,
        priceType: null,
        modelPriceId: null,
        calculateMethod: null,
        calculateValue: null,
        merchantIdList: [],
      },

      editorFormRules: {
        modelId: [{required: true, message: "请输入机型", trigger: "change"}],
        brandId: [{required: true, message: "请选择品牌", trigger: "change"}],
        categoryId: [
          {required: true, message: "请选择分类", trigger: "change"},
        ],
        gradeId: [{required: true, message: "请选择等级", trigger: "change"}],
        serviceId: [
          {required: true, message: "请选择回收商", trigger: "change"},
        ],
        skuId: [
          {required: true, message: "请选择SKU名称", trigger: "change"},
        ],
        price: [
          {required: true, message: "请输入基准价格", trigger: "change"},
        ],
        scope: [
          {required: true, message: "请选择等级适用范围", trigger: "change"},
        ],
      },

      dlgType: "change",

      // 选择
      loading: false,
      listLoading: false,

      queryCategoryOptions: [],
      queryBrandOptions: [],
      queryServiceList: [],
      queryGradeList: [],
      queryModelList: [],

      otherGradeList: [],

      editGradeList: [],
      editModelList: [],
      editBrandOptions: [],
      editSkuList: [],

      merchantIdList: [],
      editMerchantList: [],

      fullscreenLoading: false,
      calculatePrice: '',
      querySkuList:[]
    };
  },
  watch: {},
  computed: {},
  methods: {
    deleteBasePrice(id) {
      let self = this
      self.$confirm('是否删除').then(() => {
        self.$api.deleteModelPriceChangeApply({id: id}).then(res => {
          if (res.code === 200) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.getModelPriceListSearch()
          }
        })
      })
    },
    getQuerySkuList() {
      let self = this;
      let modelId = self.queryParamForm.modelId;
      if (modelId === "") {
        this.$set(this, "querySkuList", []);
        self.$set(self.queryParamForm, "skuId", null);
      } else {
        this.$api.getValidSku({
          modelId: modelId,
        })
            .then((res) => {
              self.querySkuList = res.data;
              self.$set(self.queryParamForm, "skuId", null);
            });
      }
    },
     checkModelPriceChangeApplyAllPrice(){
      let self = this
      self.$confirm('是否进行价格异常校验').then(() => {
        self.$api.checkModelPriceChangeApplyAllPrice().then(res => {
          if (res.code === 200) {
            this.$message({
              message: '价格检测完成',
              type: 'success'
            });
          }
        })
      })
    },
    batchCheck(){
      let self = this
      self.$confirm('是否批量执行价格更新').then(() => {
        self.$api.batchCheckPassModelPriceChangeApply({
          categoryId: self.queryParamForm.categoryId || null,
            modelId: self.queryParamForm.modelId || null,
            brandId: self.queryParamForm.brandId || null,
            serviceId: self.queryParamForm.serviceId || null,
            gradeId: self.queryParamForm.gradeId || null,
            skuId:self.queryParamForm.skuId || null,
            createBy:self.queryParamForm.createBy || null
        }).then(res => {
          if (res.code === 200) {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.getModelPriceListSearch()
          }
        })
      })
    },
    // click事件
    exportExcelData() {
      let self = this
      self.$api
          .modelPriceListSearch({
            page: self.currentPage,
            size: self.tableTotal,
            categoryId: self.queryParamForm.categoryId || null,
            modelId: self.queryParamForm.modelId || null,
            brandId: self.queryParamForm.brandId || null,
            serviceId: self.queryParamForm.serviceId || null,
            gradeId: self.queryParamForm.gradeId || null,
            skuId:self.queryParamForm.skuId || null,
            createBy:self.queryParamForm.createBy || null
          })
          .then((res) => {
            var downLoadTableData = res.data.records || [];
            require.ensure([], () => {
              const {export_json_to_excel} = require("@/vender/Export2Excel");
              const fieldName = ["编号", "定价回收商", "机型", "SKU名称", "品牌", "分类", "等级", "基准价格", "状态"];
              const filterVal = ["value", "serviceName", "modelName", "skuIdName", "brandName", "categoryName", "gradeName", "price", "status"];
              const data = downLoadTableData.map(v => filterVal.map(j => {
                if (j == "status") {
                  return v[j] == 1 ? "启用" : "禁用"
                }
                return v[j]
              }));
              export_json_to_excel(fieldName, data, "机型等级基准定价" + self.$moment(new Date()).format("YYYYMMDDHH:mm:ss"));
            });
          });
    },
    // 批量导入
    importSendInfo(file) {
      this.fullscreenLoading = true
      let formData = new FormData()
      formData.append('file', file)
      this.$api.imporModelPriceChangeApplyTemplete(formData).then(res => {
        this.fullscreenLoading = false
        if (res.code === 200) {
          this.$message({
            message: '导入成功',
            type: 'success'
          });
          this.getModelPriceListSearch()
        }
      })
      return false;
    },
    getSkuTemplete() {
      window.open(`/api/hjx/modelPrice/getModelPriceTemplete`, "_blank")
    },
    changeSkuList() {
      this.$set(this.editBasePriceForm, "skuId", null);
      this.$set(this.editBasePriceForm, "gradeId", null);
      this.$set(this.editBasePriceForm, "modelPriceId", null);
      this.$set(this.editBasePriceForm, "calculateMethod", null);
      this.$set(this.editBasePriceForm, "calculateValue", null);
      this.getSkuList();
    },

    changeSku(){
      this.$set(this.editBasePriceForm, "gradeId", null);
      this.$set(this.editBasePriceForm, "modelPriceId", null);
      this.$set(this.editBasePriceForm, "calculateMethod", null);
      this.$set(this.editBasePriceForm, "calculateValue", null);
      this.getGradeList(false);
    },


    getSkuList() {
      let self = this;
      let modelId = self.editBasePriceForm.modelId;
      if (modelId === "") {
        this.$set(this, "editSkuList", []);
      } else {
        this.$api.getValidSku({
          modelId: modelId,
        })
            .then((res) => {
              self.editSkuList = res.data;
            });
      }
    },
    //改变分类，品牌和等级集合发生变化
    changeOtherOptions(isQuery) {
      let self = this;
      if (isQuery) {
        this.$set(this.queryParamForm, "brandId", null);
        this.$set(this.queryParamForm, "gradeId", null);
        this.$set(this.queryParamForm, "modelId", null);
        this.$set(this.queryParamForm, "skuId", null);
        this.$set(this, "queryModelList", []);
        this.$set(this, "querySkuList", []);
        this.$set(this, "queryBrandOptions", []);
      } else {
        this.$set(this.editBasePriceForm, "brandId", null);
        this.$set(this.editBasePriceForm, "gradeId", null);
        this.$set(this.editBasePriceForm, "modelId", null);
        this.$set(this.editBasePriceForm, "skuId", null);
        this.$set(this.editBasePriceForm, "modelPriceId", null);
        this.$set(this.editBasePriceForm, "calculateMethod", null);
        this.$set(this.editBasePriceForm, "calculateValue", null);
        this.$set(this, "editModelList", []);
      }
      self.getBrandOptions(isQuery);
      self.getGradeList(isQuery);

      // self.changeOtherGrade(isQuery);

    },

    changeBrand(isQuery){
      let self = this;
      if (isQuery) {
        this.$set(this.queryParamForm, "gradeId", null);
        this.$set(this.queryParamForm, "modelId", null);
        this.$set(this, "queryModelList", []);
      } else {
        this.$set(this.editBasePriceForm, "gradeId", null);
        this.$set(this.editBasePriceForm, "modelId", null);
        this.$set(this.editBasePriceForm, "skuId", null);
        this.$set(this.editBasePriceForm, "modelPriceId", null);
        this.$set(this.editBasePriceForm, "calculateMethod", null);
        this.$set(this.editBasePriceForm, "calculateValue", null);
        this.$set(this, "editModelList", []);
      }
      self.getBrandOptions(isQuery);
      self.getGradeList(isQuery);
      self.getModelList(isQuery);
    },
    //机型
    getModelList(isQuery) {
      let brandId = isQuery
          ? this.queryParamForm.brandId
          : this.editBasePriceForm.brandId;
      if (isQuery) {
        this.$set(this.queryParamForm, "modelId", null)
        this.$set(this.queryParamForm, "skuId", null)
        this.$set(this, "querySkuList", [])
      }

      // : this.$set(this.editBasePriceForm, "modelId", null);
      if (brandId === "") {
        this.$set(this, isQuery ? "queryModelList" : "editModelList", []);
      } else {
        let self = this;
        self.$api
            .getClass({
              brandId: brandId,
              typeKey: "phoneModal",
              status: 1,
              page: 1,
              size: 100000,
            })
            .then((res) => {
              isQuery
                  ? (self.queryModelList = res.data.records || [])
                  : (self.editModelList = res.data.records || []);
            });
      }
    },
    //等级
    getGradeList(isQuery) {
      let self = this;
      let categoryId = isQuery
          ? this.queryParamForm.categoryId
          : this.editBasePriceForm.categoryId;
      if (categoryId === "") {
        this.$set(this, isQuery ? "queryGradeList" : "editGradeList", []);
      } else {
        this.$api
            .getValidModelGrade({
              categoryId: categoryId,
            })
            .then((res) => {
              isQuery
                  ? (self.queryGradeList = res.data || [])
                  : (self.editGradeList = res.data || []);
            });
      }
    },
    //回收商集合
    getServiceList() {
      let self = this;
      this.$api.getValidHjxServiceProvider().then((res) => {
        self.queryServiceList = res.data || [];
      });
    },
    // 分页函数
    handleSizeChange(val) {
      // console.log(val);
      this.pageSize = val;
      // 每次调整pagesize后，跳回第一页，保证有数据及请求不会报错
      this.handleCurrentChange(1);
    },
    handleCurrentChange(val) {
      this.currentPage = val;

      // 重新请求表格数据
      this.getModelPriceListSearch();
    },

    // 获取表格数据
    getModelPriceListSearch() {
      let self = this;
      this.listLoading = true;
      self.$api
          .modelPriceChangeApplyListSearch({
            page: self.currentPage,
            size: self.pageSize,
            categoryId: self.queryParamForm.categoryId || null,
            modelId: self.queryParamForm.modelId || null,
            brandId: self.queryParamForm.brandId || null,
            serviceId: self.queryParamForm.serviceId || null,
            gradeId: self.queryParamForm.gradeId || null,
            skuId:self.queryParamForm.skuId || null,
            createBy:self.queryParamForm.createBy || null
          })
          .then((res) => {
            self.tableData = res.data.records || [];
            self.tableTotal = res.data.total;
            this.listLoading = false;
          });
    },

    // 添加
    addBasePrice() {
      this.dlgType = "new";
      this.reset();
      this.isDlg = true;
      this.getValidMerchant();
    },

    // 表单重置
    reset() {
      this.editBasePriceForm = {
        id: null,
        value: null,
        price: 0,
        categoryId: null,
        modelId: null,
        brandId: null,
        gradeId: null,
        scope: null,
        scopeMerchant: null,
        serviceId: null,
        skuId: null,
        priceType: null,
        modelPriceId: null,
        calculateMethod: null,
        calculateValue: null,
        merchantIdList: [],
      };
      this.resetForm("editBasePriceForm");
      // this.$nextTick(() => {
      //   this.$refs['editBasePriceForm'].clearValidate()
      // })
      this.editGradeList = [];
      this.editModelList = [];
      this.editBrandOptions = [];
      this.editSkuList = [];
      this.merchantIdList = [];
      this.otherGradeList = [];
    },

    // 修改
    editormodel(row) {
      let self = this;
      this.reset();
      const id = {
        id: row.id
      };
      this.$api.modelPriceChangeApplyById(id).then(
          response => {
            self.editBasePriceForm = response.data;
            console.log(response.data);
            self.isDlg = true;
            self.dlgType = "change";

            // const modelId = row.modelId;
            // self.editBasePriceForm.modelId=modelId;
            // const skuId = row.skuId;
            // self.editBasePriceForm.skuId=skuId;
            //
            //
            self.getBrandOptions(false);
            self.getModelList(false);
            self.getGradeList(false);
            self.getSkuList();
            self.getValidMerchant();
            if (self.editBasePriceForm.priceType === 1) {
              self.getOtherGrade();
            }

            const merchantIds = self.editBasePriceForm.scopeMerchant;
            if (merchantIds != null) {
              self.merchantIdList = merchantIds.split(",").map((str) => parseInt(str, 10));
            }
          }
      )
      // const modelId = row.modelId;
      // const skuId = row.skuId;
      //
      // const price = row.price;
      //
      //
      // self.getBrandOptions(false);
      // self.getModelList(false);
      // self.getGradeList(false);
      //
      // this.$set(this.editBasePriceForm, "brandId", row.brandId);
      // this.$set(this.editBasePriceForm, "gradeId", row.gradeId);
      // this.$set(this.editBasePriceForm, "modelId", modelId);
      // this.$set(this.editBasePriceForm, "price", price);
      //
      // const merchantIds = self.editBasePriceForm.scopeMerchant;
      // if (merchantIds != null) {
      //   self.merchantIdList = merchantIds.split(",").map((str) => parseInt(str, 10));
      // }
      // self.changeSkuList();
      // this.$set(this.editBasePriceForm, "skuId", skuId);
      // this.$set(this.editBasePriceForm, "modelPriceId", row.modelPriceId);
      // self.changeOtherGrade(false);

    },

    // 关闭编辑对话框
    closeEditormodelDlg() {
      this.isDlg = false;
    },

    checkModelPriceChangeApplyPrice(){
       let self = this;
      this.$refs["editBasePriceForm"].validate((valid) => {
        if (valid) {
          let params = this.editBasePriceForm;
          // console.log(params);
          self.$api.checkModelPriceChangeApplyPrice(params).then((res) => {
            if (res.code === 200) {
              this.$message({
                message: "检验正常",
                type: "success",
              });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    // 提交编辑（新建或者修改）
    submitEditor() {
      let self = this;
      this.$refs["editBasePriceForm"].validate((valid) => {
        if (valid) {
          let params = this.editBasePriceForm;
          // console.log(params);
          self.$api.updateModelPriceChangeApply(params).then((res) => {
            if (res.code === 200) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              self.getModelPriceListSearch();
              self.closeEditormodelDlg();
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    getBrandOptions(isQuery) {
      let categoryId = isQuery
          ? this.queryParamForm.categoryId
          : this.editBasePriceForm.categoryId;

      if (categoryId === "") {
        this.$set(this, isQuery ? "queryBrandOptions" : "editBrandOptions", []);
      } else {
        let self = this;
        self.$api
            .getClass({
              categoryId: categoryId,
              typeKey: "phoneBrand",
              status: 1,
              page: 1,
              size: 100000,
            })
            .then((res) => {
              isQuery
                  ? (self.queryBrandOptions = res.data.records || [])
                  : (self.editBrandOptions = res.data.records || []);
            });
      }
    },

    getCategroyOptions() {
      let self = this;
      this.$api
          .getClass({
            typeKey: "category",
            status: 1,
            page: 1,
            size: 100000,
          })
          .then((res) => {
            self.queryCategoryOptions = res.data.records || [];
          });
    },

    changeStatus(row, newStatus) {
      let self = this;
      row.status = newStatus;
       self.$confirm('是否执行价格更新').then(() => {
            this.$api.updateModelPriceChangeApply(row).then((res) => {
              if (res.code === 200) {
                this.$message({
                  message: "修改成功",
                  type: "success",
                });
                self.getModelPriceListSearch();
              }
            });
      })
    },
    getSelectMerchantValue(values) {
      let self = this;
      self.$set(self.editBasePriceForm, "merchantIdList", values);
      if (self.merchantIdList.length == self.editMerchantList.length) {
        self.allSelectMerchantFlag = true
      } else {
        self.allSelectMerchantFlag = false
      }

    },

    //有效商户
    getValidMerchant() {
      let self = this;
      this.$api.getValidMerchant().then((res) => {
        self.editMerchantList = res.data;
      });
    },
    changeCalculatePrice() {
      if (this.editBasePriceForm.priceType === 1 && this.editBasePriceForm.modelPriceId != null && this.editBasePriceForm.calculateMethod != null && this.editBasePriceForm.calculateValue != null) {
        if (this.otherGradeList.length > 0) {
          let item = this.otherGradeList.find((item) => item.id === this.editBasePriceForm.modelPriceId);
          if (item != null) {

            let value = this.editBasePriceForm.calculateMethod === 0 ? parseInt(item.price) + parseInt(this.editBasePriceForm.calculateValue) : item.price * this.editBasePriceForm.calculateValue / 100;
            // console.log(item);
            this.calculatePrice = item.price + (this.editBasePriceForm.calculateMethod === 0 ? '+' : "*") + this.editBasePriceForm.calculateValue + (this.editBasePriceForm.calculateMethod === 1 ? '/100' : '') + "=" + value;
          }
        }
      } else {
        this.calculatePrice = '';
      }
    },

    changeGrade() {
      this.editBasePriceForm.modelPriceId = null;
      this.getOtherGrade();
    },
    getOtherGrade() {
      let self = this;
      if (self.editBasePriceForm.categoryId != null && self.editBasePriceForm.modelId != null && self.editBasePriceForm.brandId != null && self.editBasePriceForm.serviceId != null && self.editBasePriceForm.skuId != null && self.editBasePriceForm.gradeId != null) {
        this.$api
            .modelPriceListOther({
              categoryId: self.editBasePriceForm.categoryId || null,
              modelId: self.editBasePriceForm.modelId || null,
              brandId: self.editBasePriceForm.brandId || null,
              serviceId: self.editBasePriceForm.serviceId || null,
              skuId: self.editBasePriceForm.skuId || null,
              gradeId: self.editBasePriceForm.gradeId || null,
            })
            .then((res) => {
              self.otherGradeList = res.data || [];
              this.changeCalculatePrice();
            });
      }
    },

    changePriceType() {
      this.editBasePriceForm.price = null;
      this.editBasePriceForm.modelPriceId = null;
      this.editBasePriceForm.calculateMethod = null;
      this.editBasePriceForm.calculateValue = null;
    }
  },
  created() {
    this.getModelPriceListSearch();
    this.getCategroyOptions();
    this.getServiceList();

  },
  mounted() {
  },
};
</script>
<style lang="less" scoped>
.topselect {
  ::v-deep {
    .el-input__inner {
      height: 120px;
    }

    .el-input__prefix,
    .el-input__suffix {
      height: 120px;
    }

    /* 下面设置右侧按钮居中 */

    .el-input__suffix {
      top: 5px;
    }

    .el-input__icon {
      line-height: inherit;
    }

    .el-input__suffix-inner {
      display: inline-block;
    }
  }
}

.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.el-col {
  margin-left: 5px;

  &:first-child {
    margin-left: 0;
  }
}
</style>
